<template>
    <span :title="title"
      class="van-ellipsis"
      style="cursor:pointer;">{{ticketType.name}}</span>
</template>

<script>
export default {
  name: "TicketType",

  props: ['id'],

  data() {
    return {
        title : "",
        ticketType : {}
    };
  },

  watch : {
    id() {
      this._onLoad();
    }
  },

  mounted() {
    this._onLoad();
  },

  methods: {
    _onLoad() {
      // console.log('#30 TicketType _onLoad', this.id, this);

      if ( !this.id ) {
          this.ticketType = {};
          return;
      }

      var _this = this;

      // 初始化
      _this.ticketType = {};

      if ( !window.TicketTypeList ) {
          window.TicketTypeList = [];
      }

      window.TicketTypeList.push(this);

      clearTimeout(window.TicketTypeTimeoutId);
      window.TicketTypeTimeoutId = setTimeout(this._doLoad, 200);
    },

    findTypeById(list, id) {
        for ( var i=0; i < list.length; i++ ) {
          if(list[i].id + "" == id + "" ) {
            return list[i];
          }
        }

        return { id : id, name : '类型 ' + id , description : '未知类型 ' + id };
    },

    _doLoad() {
        var _this = this;

        if ( !window.TicketTypeList ) {
            console.log("#51 window.TicketTypeList=", window.TicketTypeList);

            clearTimeout(window.TicketTypeTimeoutId);
            window.TicketTypeTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
            return;
        }

        sdk.TicketTypeApi().listByIdsCached({
          ids : window.TicketTypeList.map(e => e.id)
        }).then(res=> {
          for ( var i=0; i < window.TicketTypeList.length; i++ ) {
            var _each = window.TicketTypeList[i];
            var _ticketType = _this.findTypeById(res, _each.id);
            _each.title = '#' + _ticketType.id + ' ' + _ticketType.name + '\n'+ JSON.stringify(_ticketType);
            _each.ticketType = _ticketType;
          }

          // 清理
          window.TicketTypeTimeoutId = null;
          window.TicketTypeList = null;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketType.vue